import React from 'react';
import MuiCheckbox, { CheckboxProps } from '@mui/material/Checkbox';
import { checkboxSx } from './Checkbox.styles';
import { SxProps, Theme } from '@mui/material/styles';

export const Checkbox = React.forwardRef<HTMLButtonElement, CheckboxProps>((props, ref) => {
  return (
    <MuiCheckbox
      ref={ref}
      {...props}
      sx={[checkboxSx, props.sx] as SxProps<Theme>}
    />
  );
});

Checkbox.displayName = 'Checkbox';